import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CopyOutlined } from '@ant-design/icons';
import { message, Button } from "antd";
import "../styles/components/copy-clipboard.scss";

class CopyToClip extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.data ? this.props.data : "",
      copied: false
    };
  }

  onCopy = () => {
    this.setState({ copied: true });
    message.success("Copied!");
  };

  render() {
    return (
      <React.Fragment>
        <input
          value={this.props.data}
          onChange={({ target: { value } }) =>
            this.setState({ value, copied: false })
          }
          className="copy-clipboard--input"
        />
        <CopyToClipboard text={this.props.data} onCopy={this.onCopy}>
          <Button
            className="copy-clipboard--button"
            type="primary"
            shape="round"
            icon={<CopyOutlined />}
          >
            Copy
          </Button>
        </CopyToClipboard>
      </React.Fragment>
    );
  }
}

export default CopyToClip;
